// extracted by mini-css-extract-plugin
module.exports = {"notfound":"Error_notfound__1Vs0O","pageNotfound":"Error_pageNotfound__2NZ1T","explanation":"Error_explanation__1tdHU","button":"Error_button__1IjL9"};